<template>
  <div class="overview-items-wrapper">
    <div
      v-for="(nRate, i) in nightlyRates"
      :key="nRate.date"
      class="overview-item"
      :class="[
        { 'small-margin': i < nightlyRates.length - 1 }
      ]"
    >
      <div class="item-label section-label">
        {{nRate.date | dateFilter}}
      </div>
      <div
        class="item-value"
        :class="[{ success: parseInt(nRate.price) === 0 }]"
      >
        <span>
          <span v-if="parseInt(nRate.price) === 0" class="label">{{tc('booking.complimentary')}}</span>
          {{getDisplayPrice({price: nRate.price})}}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { formatDateZone } from '@utils/date-helpers'
export default {
  name: 'overview-nightly-rates',
  props: {
    nightlyRates: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters('currency', ['getDisplayPrice']),
    ...mapGetters('i18n', ['tc'])
  },
  filters: {
    dateFilter(val) {
      return formatDateZone(val, null, 'ddd[,] MMM[.] D[,] YYYY')
    }
  }
}
</script>